import type { IdentifyTraits, RudderAnalytics } from "@rudderstack/analytics-js";

import type { IdentifyTraitsData } from "@shared/hooks/useIdentifyTraitsData/useIdentifyTraitsData";

const useIdentify = (shouldCall: boolean) => {
  const identify = (analytics: RudderAnalytics, traitsData: IdentifyTraitsData) => {
    if (!shouldCall) return;

    const traits: IdentifyTraits = {
      hasAcceptedLabsBaa: traitsData.hasAcceptedLabsBaa,
      hasSentFirstTpWithLabs: traitsData.hasSentFirstTpWithLabs,
      hasSentSecondTpWithLabs: traitsData.hasSentSecondTpWithLabs,
      hasSentFourthTpWithLabs: traitsData.hasSentFourthTpWithLabs,
      hasSentSixthTpWithLabs: traitsData.hasSentSixthTpWithLabs,
      anyCredentialApproved: traitsData.anyCredentialApproved,
      createdAt: traitsData.createdAt.toString(),
      firstName: traitsData.firstName,
      location: traitsData.location,
      role: traitsData.role,
      intent: traitsData.intent,
      modality: traitsData.modality,
      hasMargin: traitsData.hasMargin,
      promoOptInStatus: traitsData.promoOptInStatus,
      promoActiveOptInPeriodEndsAt: traitsData.promoActiveOptInPeriodEndsAt,
      colorScheme: traitsData.colorScheme,
    };

    traits["appcues:user_id_signature"] = traitsData.appcuesUserIdSignature;

    analytics?.identify(traitsData?.userId, traits);
  };

  return identify;
};

export { useIdentify };
